import { Mail, MapPin, Phone } from "lucide-react";
import { QuoteForm } from "./QuoteForm";
import { useI18n } from "@/i18n";
import { business } from "@/config/business";
import { trackAnalyticsEvent } from "@/lib/analytics";
import { getMarketingCopy } from "@/i18n/marketing-copy";

export function ContactCta() {
  const { t, locale } = useI18n();
  const contact = getMarketingCopy(locale)?.contactDetails;

  return (
    <section id="contact" className="section-y bg-slate-deep">
      <div className="container-page grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-16">
        <div>
          <p className="eyebrow">{t.form.eyebrow}</p>
          <h2 className="display-2 mt-3 text-balance text-primary-foreground">
            {t.finalCta.title}
          </h2>
          <p className="mt-4 max-w-md leading-relaxed text-primary-foreground/70">
            {t.finalCta.body}
          </p>

          <dl className="mt-10 space-y-5 border-t border-primary-foreground/15 pt-8 text-sm">
            <div className="flex items-center gap-3">
              <Phone className="size-4 shrink-0 text-accent" aria-hidden="true" />
              <dt className="sr-only">{t.form.phone}</dt>
              <dd>
                <a
                  href={business.phoneHref}
                  className="text-primary-foreground underline-offset-4 hover:underline"
                  onClick={() =>
                    trackAnalyticsEvent({ event: "phone_click", link_location: "contact_section" })
                  }
                >
                  {business.phone}
                </a>
              </dd>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="size-4 shrink-0 text-accent" aria-hidden="true" />
              <dt className="sr-only">{t.form.email}</dt>
              <dd>
                <a
                  href={`mailto:${business.email}`}
                  className="text-primary-foreground underline-offset-4 hover:underline"
                >
                  {business.email}
                </a>
              </dd>
            </div>
            <div className="flex items-center gap-3">
              <MapPin className="size-4 shrink-0 text-accent" aria-hidden="true" />
              <dt className="sr-only">{contact?.serviceArea ?? "Service area"}</dt>
              <dd className="text-primary-foreground/70">
                {contact?.serviceArea ?? "Service region"}:{" "}
                {contact?.region ?? "Metro Vancouver & the Lower Mainland"}
              </dd>
            </div>
            {/* A <div> inside <dl> must itself wrap a dt/dd group. */}
            <div className="text-primary-foreground/60">
              <dt className="sr-only">{contact?.hoursLabel ?? "Hours"}</dt>
              <dd>
                {contact?.hoursLabel ?? "Phone & enquiry hours"}: {contact?.hours ?? business.hours}
              </dd>
            </div>
          </dl>
        </div>

        <QuoteForm />
      </div>
    </section>
  );
}
